import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

// Component to display the 3D viewer in AI Product Staging dialog
// Uses direct DOM manipulation to move the ZakekeViewer element into this container
// This preserves the 3D viewer's internal state (no React unmount/remount)
// so that getOnlineScreenshot and other library methods continue to work

export const Preview3DView: React.FC<{ className?: string }> = ({ className }) => {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const viewerElement = document.querySelector('.zakeke-viewer-container') as HTMLElement | null;
		if (!viewerElement || !containerRef.current) return;

		const originalParent = viewerElement.parentElement;
		if (!originalParent) return;

		// Create placeholder to remember original position in the DOM
		const placeholder = document.createElement('div');
		placeholder.style.display = 'none';
		placeholder.setAttribute('data-placeholder', 'viewer');
		originalParent.insertBefore(placeholder, viewerElement);

		// Move viewer into our container
		containerRef.current.appendChild(viewerElement);

		// Trigger resize events to ensure the 3D viewer resizes properly
		const triggerResize = () => window.dispatchEvent(new Event('resize'));
		const timer1 = setTimeout(triggerResize, 100);
		const timer2 = setTimeout(triggerResize, 300);
		const timer3 = setTimeout(triggerResize, 500);

		return () => {
			clearTimeout(timer1);
			clearTimeout(timer2);
			clearTimeout(timer3);

			// Move viewer back to its original position
			if (placeholder.parentElement) {
				originalParent.insertBefore(viewerElement, placeholder);
				placeholder.remove();
			}

			// Trigger resize after moving back
			setTimeout(triggerResize, 100);
			setTimeout(triggerResize, 300);
		};
	}, []);

	return <Preview3DViewContainer ref={containerRef} className={className} />;
};

const Preview3DViewContainer = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
	display: block;
	background: #f2f2f2;
	border-radius: 1rem;
	overflow: hidden;
	z-index: 1;

	> div {
		width: 100% !important;
		height: 100% !important;
		position: absolute !important;
		top: 0 !important;
		left: 0 !important;
	}

	canvas {
		width: 100% !important;
		height: 100% !important;
		display: block !important;
		visibility: visible !important;
		opacity: 1 !important;
		transform: none !important;
		position: absolute !important;
		top: 0 !important;
		left: 0 !important;
		background: #f2f2f2 !important;
	}
`;
